function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "{title}");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9,3H9A3.61,3.61,0,0,0,7,6.24V8.38A3.62,3.62,0,0,1,3.38,12h0A3.62,3.62,0,0,1,7,15.62v2.14A3.61,3.61,0,0,0,9,21H9"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15,3h0a3.61,3.61,0,0,1,2,3.24V8.38A3.62,3.62,0,0,0,20.62,12h0A3.62,3.62,0,0,0,17,15.62v2.14A3.61,3.61,0,0,1,15,21h0"
});

var SvgComponent = function SvgComponent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/apis.d5770b73.svg";
export { SvgComponent as ReactComponent };